export const environment = {
  production: false,
  API_URL: 'http://64.225.29.181:80/v1'
};
